import {
  fetchV1Categories,
  searchV1Categories,
  createV1Category,
} from "@/services/v1/inventoryAPIService";

export default {
  state: {
    categories: [],
    categoryPageSize: 5,
    currentCategoryPageNumber: 1,
    totalCategoryPageNumber: 0,
    totalCategoryCount: 0,
    categorySearchQuery: "",
  },
  getters: {
    categories: (state) => state.categories,
    currentCategoryPageSize: (state) => state.categoryPageSize,
    currentCategoryPageNumber: (state) => state.currentCategoryPageNumber,
    totalCategoryPageNumber: (state) => state.totalCategoryPageNumber,
    totalCategoryCount: (state) => state.totalCategoryCount,
    categorySearchQuery: (state) => state.categorySearchQuery,
  },
  mutations: {
    SET_CATEGORIES(state, categories) {
      state.categories = categories;
    },
    SET_CATEGORY_PAGE_SIZE(state, pageSize) {
      state.categoryPageSize = pageSize;
    },
    SET_CURRENT_CATEGORY_PAGE_NUMBER(state, page) {
      state.currentCategoryPageNumber = page;
    },
    SET_TOTAL_CATEGORY_PAGE_NUMBER(state, page) {
      state.totalCategoryPageNumber = page;
    },
    SET_TOTAL_CATEGORIES_COUNT(state, count) {
      state.totalCategoryCount = count;
    },
    SET_CATEGORY_SEARCH_QUERY(state, query) {
      state.categorySearchQuery = query;
    },
  },
  actions: {
    // updateCategoryPageNumber({ commit, state }, { page = 1 } = {}) {
    //   commit(
    //     "SET_CURRENT_CATEGORY_PAGE_NUMBER",
    //     state.currentCategoryPageNumber + page
    //   );
    // },
    async fetchCategories({ commit }, { page = 1, pageSize = 5 } = {}) {
      //   commit("SET_LOADING", true);
      try {
        const response = await fetchV1Categories(page, pageSize);
        commit("SET_CURRENT_CATEGORY_PAGE_NUMBER", response.current_page);
        commit("SET_TOTAL_CATEGORY_PAGE_NUMBER", response.total_pages);
        commit("SET_CATEGORIES", response.results);
        commit("SET_CATEGORY_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_CATEGORIES_COUNT", response.count);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        // commit("SET_LOADING", false);
        console.log("finally...");
      }
    },
    async searchCategories({ commit }, { query, page = 1, pageSize = 8 } = {}) {
      commit("SET_CATEGORY_SEARCH_QUERY", query);
      try {
        const response = await searchV1Categories(query, page, pageSize);
        commit("SET_CATEGORIES", response.results);
        commit("SET_CATEGORY_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_CATEGORIES_COUNT", response.count);
      } catch (error) {
        console.error("Error searching categories:", error);
      }
    },
    async addCategory({ commit }, category) {
      try {
        const response = await createV1Category(category);
        if (response.error) {
          const errorMessages = [];
          errorMessages.push(response.message);
          // commit("SET_ERROR", errorMessages);
          return { success: false, message: response.message };
        }
        return { success: true, data: response };
      } catch (error) {
        const errorMessages = [];
        for (const [key, value] of Object.entries(error.response.data)) {
          errorMessages.push(value[0]);
          console.log(`category create... ${key}: ${value}`);
        }
        commit("SET_ERROR", errorMessages);
        const message =
          error.response?.data?.message || "Failed to add Category.";
        return { success: false, message };
      }
    },
  },
};
